import _defineProperty from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";

/* eslint-disable prefer-arrow-callback */

/* eslint-disable arrow-body-style */
import $ from "cash-dom";
import queryString from "query-string";
export function trackShare(object, type, url) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "socialShare",
    object: object,
    type: type,
    url: url
  });
}
export function copy(el) {
  el.select();
  document.execCommand("copy");
}

function openModal(e) {
  var crh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var container = $(e.target).closest("[data-chart-container]");
  var url = $(e.target).attr("data-url"); // const params = queryString.parse(location.search);
  // const { adjustment } = params;
  // const { state } = params;

  var options = $(container).find(".charts").attr("data-options");
  var title = $(container).find(".charts").attr("data-title");
  var qs = JSON.parse(options || "{}");

  if (!qs.subtitle && !qs.title && !title) {
    qs.hideTitle = true;
  } else if (title) {
    qs.title = title;
  } // Covid Recovery Hub


  if (crh) {
    // get data for topic
    var parsedData = window.covidRecoveryHubData || [];
    var data = parsedData.find(function (i) {
      return i.bigContainer === container.find(".big-chart-card").attr("id");
    }); // get selected ticker and tab in container

    var activeTicker = container.find(".crh-charts-row-container__vertical .tiny-card.selected").parent().index();
    var activeTab = container.find(".tabs-container .tabs-tab.is-active").index(); // get options by indices

    qs = data.charts[activeTicker].options[activeTab];
  }

  var height = 520;

  if (qs.chartFootnotes || qs.chartSources) {
    height = 580;
  } // stringify nested array of objects


  Object.keys(qs).forEach(function (key) {
    if (typeof qs[key] === "object") {
      qs[key] = JSON.stringify(qs[key]);
    }
  });

  var isNull = function isNull(value) {
    return value === null || "".concat(value) === "null";
  };

  var filteredQs = Object.keys(qs).reduce(function (acc, key) {
    return isNull(qs[key]) || qs[key] === {} || qs[key] === [] || qs[key] === "[]" ? acc : _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, qs[key]));
  }, {});
  var fullUrl = "".concat(url, "?").concat(queryString.stringify(filteredQs));
  trackShare("chart", "embed", fullUrl);
  var modal = $(container).find(".chart-share-modal");
  var input = $(modal).find(".chart-share-modal__url");
  input.html("<iframe width=\"750\" height=\"".concat(height, "\" frameborder=\"0\" src=\"").concat(window.location.origin).concat(fullUrl, "\"></iframe>"));
  $(".chart-share-modal").removeClass("active");
  $(modal).find(".chart-share-modal__body").get(0).focus();
  $(modal).toggleClass("active");
  var button = $(modal).find(".chart-share-modal__button");
  button.on("click keypress", function (ev) {
    var code = ev.keyCode || ev.which;

    if (code === 1 || code === 13) {
      ev.preventDefault();
      var el = input.get(0);
      copy(el);
      $(el).next().text("Copied!");
      setTimeout(function () {
        $(el).next().text("Copy");
      }, 2000);
    }
  });
}

function downloadCsv(e) {
  var crh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var container = $(e.target).closest("[data-chart-container]");
  var url = "".concat(document.URL.replace(/#.*$/, ""), "#").concat($(container).find(".sotu__share-link-fade").attr("data-slug"));
  var options = $(container).find(".charts").attr("data-options");
  var qs = JSON.parse(options || "{}"); // Covid Recovery Hub

  if (crh) {
    // get data for topic
    var parsedData = window.covidRecoveryHubData || [];
    var data = parsedData.find(function (i) {
      return i.bigContainer === container.find(".big-chart-card").attr("id");
    }); // get selected ticker and tab in container

    var activeTicker = container.find(".crh-charts-row-container__vertical .tiny-card.selected").parent().index();
    var activeTab = container.find(".tabs-container .tabs-tab.is-active").index(); // get options by indices

    qs = data.charts[activeTicker].options[activeTab];
  }

  try {
    var metricIds = [];

    if (Object.prototype.hasOwnProperty.call(qs, "groups")) {
      metricIds = qs.metrics.flatMap(function (_ref) {
        var metrics = _ref.metrics;
        return metrics.map(function (_ref2) {
          var id = _ref2.id;
          return id;
        });
      });
    } else {
      metricIds = qs.metrics.flatMap(function (m) {
        return m.id;
      });
    }

    if (metricIds && metricIds.length) {
      window.open("https://a.usafacts.org/api/v4/Metrics/csv?ids=".concat(metricIds.join("&ids=")));
    }

    trackShare("chart", "data-download", url);
  } catch (e) {
    console.error("Unable to download CSV", {
      e: e
    });
  }
}

export default function () {
  // Page-level share buttons
  $("#share-icons__facebook").on("click", function () {
    trackShare("page", "facebook", document.URL);
    window.open("https://www.facebook.com/dialog/share?app_id=444773196460067&display=popup&href=".concat(encodeURIComponent(document.URL)), "_blank", "height=570,width=520");
  });
  $("#share-icons__twitter").on("click", function () {
    trackShare("page", "twitter", document.URL);
    window.open("https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(document.URL), "&text=").concat(encodeURIComponent(document.title), "&via=USAFacts"), "_blank", "height=570,width=520");
  });
  $("#share-icons__linkedin").on("click", function () {
    trackShare("page", "linkedin", document.URL);
    window.open("https://www.linkedin.com/shareArticle?url=".concat(encodeURIComponent(document.URL), "&title=").concat(encodeURIComponent(document.title)), "_blank", "height=570,width=520");
  });
  $("#share-icons__mail").on("click", function () {
    trackShare("page", "email", document.URL);
    window.open("mailto:?subject=".concat(encodeURIComponent(document.title), "&body=").concat(encodeURIComponent(document.URL)), "_blank", "height=570,width=520");
  });
  $("#share-icons__print").on("click", function () {
    trackShare("page", "print", document.URL);
    window.print();
  }); // Metric page charts

  $(".charts").each(function () {
    var selector = $(this).attr("id");
    var title = $(this).attr("data-title");
    var subtitle = $(this).attr("data-subtitle");

    if (subtitle) {
      title += ": ".concat(subtitle);
    }

    $(this).parent().find(".chart-share-icons__facebook").on("click keypress", function (e) {
      if (e.which === 1 || e.which === 13) {
        var chosenChart = $(this).attr("data-chart");
        window.history.replaceState({}, "", "?share=".concat(chosenChart, "#").concat(selector));
        trackShare("chart", "facebook", document.URL);
        window.open("https://www.facebook.com/dialog/share?app_id=444773196460067&display=popup&href=".concat(encodeURIComponent(document.URL)), "_blank", "height=570,width=520");
      }
    });
    $(this).parent().find(".chart-share-icons__twitter").on("click keypress", function (e) {
      if (e.which === 1 || e.which === 13) {
        var chosenChart = $(this).attr("data-chart");
        window.history.replaceState({}, "", "?share=".concat(chosenChart, "#").concat(selector));
        trackShare("chart", "twitter", document.URL);
        window.open("https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(document.URL), "&text=").concat(encodeURIComponent(title), "&via=USAFacts"), "_blank", "height=570,width=520");
      }
    });
    $(this).parent().find(".chart-share-icons__linkedin").on("click keypress", function (e) {
      if (e.which === 1 || e.which === 13) {
        var chosenChart = $(this).attr("data-chart");
        window.history.replaceState({}, "", "?share=".concat(chosenChart, "#").concat(selector));
        trackShare("chart", "linkedin", document.URL);
        window.open("https://www.linkedin.com/shareArticle?url=".concat(encodeURIComponent(document.URL), "&title=").concat(encodeURIComponent(title)), "_blank", "height=570,width=520");
      }
    });
    $(this).parent().find(".chart-share-icons__mail").on("click keypress", function (e) {
      if (e.which === 1 || e.which === 13) {
        trackShare("chart", "email", document.URL);
        window.open("mailto:?subject=".concat(encodeURIComponent(title), "&body=").concat(encodeURIComponent(document.URL)), "_blank", "height=570,width=520");
      }
    });
    $(this).parent().find(".chart-share-icons__print").on("click keypress", function (e) {
      if (e.which === 1 || e.which === 13) {
        trackShare("chart", "print", document.URL);
        window.print();
      }
    });
    $(this).parent().find(".chart-share-icons__embed").on("click keypress", function (e) {
      if (e.which === 1 || e.which === 13) {
        openModal(e);
      }
    });
    $(this).parent().find(".chart-share-icons__download").on("click keypress", function (e) {
      if (e.which === 1 || e.which === 13) {
        trackShare("chart", "download", $(e.target).parent().attr("href"));
      }
    });
  });
  $(".metric__download-button").on("click keypress", function () {
    trackShare("chart", "data-download", document.URL);
  });
  $(".chart-share-modal__bg, .chart-share-modal__close").on("click keypress", function (e) {
    if (e.which === 1 || e.which === 13) {
      $(".chart-share-modal").removeClass("active");
    }
  }); // Sotu sharing

  $(".sotu__share-icons").each(function () {
    var heading = document.title;
    var url = document.URL;
    $(this).find(".sotu-share-icons__facebook").on("click", function () {
      trackShare("page", "facebook", url);
      window.open("https://www.facebook.com/dialog/share?app_id=444773196460067&display=popup&href=".concat(encodeURIComponent(url)), "_blank", "height=570,width=520");
    });
    $(this).find(".sotu-share-icons__twitter").on("click", function () {
      trackShare("page", "twitter", url);
      window.open("https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(url), "&text=").concat(encodeURIComponent(heading), "&via=USAFacts"), "_blank", "height=570,width=520");
    });
    $(this).find(".sotu-share-icons__linkedin").on("click", function () {
      trackShare("page", "linkedin", url);
      window.open("https://www.linkedin.com/shareArticle?url=".concat(encodeURIComponent(url), "&title=").concat(encodeURIComponent(heading)), "_blank", "height=570,width=520");
    });
    $(this).find(".sotu-share-icons__mail").on("click", function () {
      trackShare("page", "email", url);
      window.open("mailto:?subject=".concat(encodeURIComponent(heading), "&body=").concat(encodeURIComponent(url)), "_blank", "height=570,width=520");
    });
    $(this).find(".sotu-share-icons__download").on("click", function () {
      trackShare("sotuPdf", "download", url);
      var w = window.open($(this).attr("data-href"), "_blank", "height=570,width=520");
      w.print();
    });
  });
  $(".sotu__share-link-fade").each(function () {
    var heading = $(this).attr("data-heading");
    var slug = $(this).attr("data-slug");
    var url = "".concat(document.URL.replace(/#.*$/, ""), "#").concat(slug);
    $(this).find(".sotu-share-icons__facebook").on("click", function () {
      trackShare("sotuSection", "facebook", url);
      window.open("https://www.facebook.com/dialog/share?app_id=444773196460067&display=popup&href=".concat(encodeURIComponent(url)), "_blank", "height=570,width=520");
    });
    $(this).find(".sotu-share-icons__twitter").on("click", function () {
      trackShare("sotuSection", "twitter", url);
      window.open("https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(url), "&text=").concat(encodeURIComponent(heading), "&via=USAFacts"), "_blank", "height=570,width=520");
    });
    $(this).find(".sotu-share-icons__linkedin").on("click", function () {
      trackShare("sotuSection", "linkedin", url);
      window.open("https://www.linkedin.com/shareArticle?url=".concat(encodeURIComponent(url), "&title=").concat(encodeURIComponent(heading)), "_blank", "height=570,width=520");
    });
    $(this).find(".sotu-share-icons__mail").on("click", function () {
      trackShare("sotuSection", "email", url);
      window.open("mailto:?subject=".concat(encodeURIComponent(heading), "&body=").concat(encodeURIComponent(url)), "_blank", "height=570,width=520");
    });
    $(this).find(".sotu-share-icons__print").on("click", function () {
      trackShare("sotuSection", "print", url);
      window.print();
    });
    $(this).find(".sotu-share-icons__download-csv").on("click", downloadCsv);
    $(this).find(".sotu-share-icons__embed").on("click", openModal);
  }); // Publication charts and custom charts w/ anchor link

  $(".custom-chart").each(function () {
    var title = $(this).attr("data-title");
    var hash = "#".concat($(this).attr("id"));
    var url = document.URL;
    $(this).find(".chart-share-icons__facebook").on("click", function () {
      window.history.replaceState({}, "", hash);
      trackShare("publicationChart", "facebook", url);
      window.open("https://www.facebook.com/dialog/share?app_id=444773196460067&display=popup&href=".concat(encodeURIComponent(url)), "_blank", "height=570,width=520");
    });
    $(this).find(".chart-share-icons__twitter").on("click", function () {
      window.history.replaceState({}, "", hash);
      trackShare("publicationChart", "twitter", url);
      window.open("https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(url), "&text=").concat(encodeURIComponent(title), "&via=USAFacts"), "_blank", "height=570,width=520");
    });
    $(this).find(".chart-share-icons__linkedin").on("click", function () {
      window.history.replaceState({}, "", hash);
      trackShare("publicationChart", "linkedin", url);
      window.open("https://www.linkedin.com/shareArticle?url=".concat(encodeURIComponent(url), "&title=").concat(encodeURIComponent(title)), "_blank", "height=570,width=520");
    });
    $(this).find(".chart-share-icons__mail").on("click", function () {
      window.history.replaceState({}, "", hash);
      trackShare("publicationChart", "email", url);
      window.open("mailto:?subject=".concat(encodeURIComponent(title), "&body=").concat(encodeURIComponent(url)), "_blank", "height=570,width=520");
    });
    $(this).find(".chart-share-icons__embed").on("click", openModal);
  }); // Share by provided attributes

  $(".section-share-icons__facebook").on("click", function () {
    var url = $(this).attr("data-href"); // const title = $(this).attr("data-title");

    var source = $(this).attr("data-source");
    trackShare(source, "facebook", url);
    window.open("https://www.facebook.com/dialog/share?app_id=444773196460067&display=popup&href=".concat(encodeURIComponent(url)), "_blank", "height=570,width=520");
  });
  $(".section-share-icons__twitter").on("click", function () {
    var url = $(this).attr("data-href");
    var title = $(this).attr("data-title");
    var source = $(this).attr("data-source");
    trackShare(source, "twitter", url);
    window.open("https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(url), "&text=").concat(encodeURIComponent(title), "&via=USAFacts"), "_blank", "height=570,width=520");
  });
  $(".section-share-icons__linkedin").on("click", function () {
    var url = $(this).attr("data-href");
    var title = $(this).attr("data-title");
    var source = $(this).attr("data-source");
    trackShare(source, "linkedin", url);
    window.open("https://www.linkedin.com/shareArticle?url=".concat(encodeURIComponent(url), "&title=").concat(encodeURIComponent(title)), "_blank", "height=570,width=520");
  });
  $(".section-share-icons__mail").on("click", function () {
    var url = $(this).attr("data-href");
    var title = $(this).attr("data-title");
    var source = $(this).attr("data-source");
    trackShare(source, "email", url);
    window.open("mailto:?subject=".concat(encodeURIComponent(title), "&body=").concat(encodeURIComponent(url)), "_blank", "height=570,width=520");
  });
  $(".section-share-icons__embed").on("click", function (e) {
    openModal(e, true);
  });
  $(".section-share-icons__download-csv").on("click", function (e) {
    downloadCsv(e, true);
  }); // track pdf downloads sitewide

  $('a[href$=".pdf"]').on("click", function () {
    var url = $(this).attr("href");
    var title = $(this).text().trim();
    trackShare("pdf", "download", [url, title].join(" | "));
  });
}